import gql from 'graphql-tag';
import * as Urql from 'urql';

import * as Types from './types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetTradelanesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetTradelanesQuery = {
  __typename?: 'query_root';
  glec_tradelanes: Array<{
    __typename?: 'glec_tradelanes';
    group?: string | null;
    tradelane: string;
  }>;
};

export const GetTradelanesDocument = gql`
  query GetTradelanes {
    glec_tradelanes {
      group
      tradelane
    }
  }
`;

export function useGetTradelanesQuery(
  options?: Omit<Urql.UseQueryArgs<GetTradelanesQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GetTradelanesQuery, GetTradelanesQueryVariables>({
    query: GetTradelanesDocument,
    ...options,
  });
}
